import CheckIns from './CheckIns';

export default CheckIns;
